<template>
  <section :class="['section', 'section-wrap', $route.name]">
    <navigation></navigation>
    <div class="columns is-marginless">
      <div
        v-if="notPrinting"
        :class="[
          'column',
          'aside',
          'hero',
          'is-fullheight',
          'is-full-tablet',
          'is-3-desktop',
          'is-2-widescreen',
          'nav-left',
          { 'is-nav-toggle': navToggle }
        ]"
      >
        <left-menu v-if="isAuth"></left-menu>
      </div>
      <div
        class="column col-content is-9-desktop is-10-widescreen is-full-tablet is-mobile"
      >
        <div>
          <section class="section">
            <transition name="slide">
              <router-view></router-view>
            </transition>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import navigation from "@/components/Navigation";
import leftMenu from "@/components/LeftMenu";
import AuthService from "@/services/AuthService";
import SettingsService from "@/services/SettingsService";

export default {
  name: "app",

  components: {
    navigation,
    leftMenu
  },

  data() {
    return {};
  },

  computed: {
    isAuth() {
      return this.$store.state.isAuth;
    },
    practice() {
      return this.$store.getters["practice/current"];
    },
    navToggle() {
      return this.$store.getters.navToggle;
    },
    notPrinting() {
      // for some reason display: flex is causing the second column not to print, so using this work around for now
      return !this.$store.getters.printing;
    }
  },

  mounted() {
    SettingsService.whiteLabel();
    AuthService.getUser();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
